let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fKONs")).then(() => parcelRequire('g30aC'));